/**
 * Handle URL parameter prefill for form fields
 * Hides fields by default, shows and populates them if URL param exists
 *
 * @param {string} formId - The form data-formid attribute value
 * @param {Array} fields - Array of field config objects with: { param, fieldId, inputId, makeFieldReadOnly = true, hideFieldByDefault = true, hideFieldIfActive = null }
 */
function initFormFieldFromUrl(formId, fields) {
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector(`form[data-formid="${formId}"]`);
    if (!form) return;

    const urlParams = new URLSearchParams(window.location.search);

    fields.forEach(
      ({
        param,
        fieldId,
        inputId,
        makeInputReadOnly = true,
        hideFieldByDefault = true,
        hideFieldsIfActive = [],
      }) => {
        const fieldEl = form.querySelector(fieldId);
        const inputEl = form.querySelector(inputId);
        const paramValue = urlParams.get(param);

        if (!fieldEl || !inputEl) return;

        // Show or hide field by default
        fieldEl.style.display = hideFieldByDefault ? 'none' : 'block';

        // Show field if param exists
        if (paramValue) {
          // Show field
          fieldEl.style.display = '';

          // Populate field value
          fieldEl.value = paramValue;

          // Make field readonly if needed
          inputEl.readOnly = makeInputReadOnly;

          // Hide dependent fields if needed
          if (hideFieldsIfActive) {
            hideFieldsIfActive.forEach((hideFieldId) => {
              const hideEl = form.querySelector(hideFieldId);
              if (hideEl) {
                hideEl.style.display = 'none';
                const hideInput = hideEl.querySelector('input, select, textarea');
                if (hideInput) {
                  hideInput.value = '';
                }
              }
            });
          }
        }
      }
    );
  });
}

// Form configurations
const formConfigs = [
  {
    // Afspraak inplannen (schedule appointment)
    formId: '8',
    fields: [
      {
        param: 'park',
        fieldId: '#field_8_5',
        inputId: '#input_8_5',
        makeInputReadOnly: false,
        hideFieldByDefault: false,
      },
    ],
  },
  {
    // Bezichtiging aanvragen (request viewing)
    formId: '4',
    fields: [
      { param: 'property', fieldId: '#field_4_10', inputId: '#input_4_10' },
      { param: 'project', fieldId: '#field_4_11', inputId: '#input_4_11' },
    ],
  },
  {
    // Woning reserveren (reserve property)
    formId: '5',
    fields: [
      {
        param: 'property',
        fieldId: '#field_5_10',
        inputId: '#input_5_10',
        hideFieldByDefault: false,
      },
    ],
  },
  {
    // Brochure aanvragen (request brochure)
    formId: '3',
    fields: [
      {
        param: 'event',
        fieldId: '#field_3_19',
        inputId: '#input_3_19',
        hideFieldsIfActive: ['#field_3_17'],
      },
      {
        param: 'theme',
        fieldId: '#field_3_20',
        inputId: '#input_3_20',
        hideFieldsIfActive: ['#field_3_17'],
      },
    ],
  },
  {
    // Aanmelden open dag (open day registration)
    formId: '9',
    fields: [{ param: 'event', fieldId: '#field_9_19', inputId: '#input_9_19' }],
  },
  {
    // Contact opnemen woning (contact property)
    formId: '10',
    fields: [{ param: 'property', fieldId: '#field_10_10', inputId: '#input_10_10' }],
  },
];

// Initialize all forms
formConfigs.forEach(({ formId, fields }) => {
  initFormFieldFromUrl(formId, fields);
});
